import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { ComponentTheme } from '@helpers/themeEnum';
import { headingStyles } from '@helpers/typography';
import { VideoEmbedStyles } from '@stories/Components/Misc/VideoEmbed/VideoEmbed.styles';
import styled from 'styled-components';
const Container = styled.div `
  --widgetThemeColor: var(--primaryPageThemeColor);

  &[data-widget-theme=${ComponentTheme.Orange}] {
    --widgetThemeColor: ${brand.orange.base};
  }

  &[data-widget-theme=${ComponentTheme.Green}] {
    --widgetThemeColor: ${brand.green.base};
  }

  &[data-widget-theme=${ComponentTheme.Blue}] {
    --widgetThemeColor: ${brand.blue.base};
  }

  &[data-widget-theme=${ComponentTheme.Yellow}] {
    --widgetThemeColor: ${brand.yellow.base};
  }

  overflow: hidden;
  text-decoration: none;
  display: block;
`;
const Inner = styled.div `
  position: relative;
  display: grid;
`;
const MediaContainer = styled.div `
  display: grid;
  position: relative;
  grid-template-columns: repeat(6, 1fr);
`;
const MediaHolder = styled.div `
  ${imageWrapperPreserveRatio(415, 233, 415, 233)}
  overflow: hidden;
  border-radius: ${fluid(25, 32)};
  grid-column: span 5;

  [data-is-playing='true'] & {
    grid-column: span 6;
  }

  ${VideoEmbedStyles.VideoPlayer} {
    .react-player__preview {
      border-radius: ${fluid(25, 32)};
    }
  }

  ${VideoEmbedStyles.PlayIcon} {
    height: ${fluid(64, 75)};
    width: ${fluid(64, 75)};
  }
`;
const ImageDesktop = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const ImageMobile = styled.img `
  ${transition('transform')};
  ${imageCoverContainer()}

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ContentArea = styled.div `
  [data-has-image='false'] & {
    @media ${from(Device.Tablet)} {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
`;
const QuoteIconImageArea = styled.div `
  display: block;
  position: absolute;
  right: 17px;
  bottom: -22px;

  svg {
    height: ${fluid(60, 80)};
    color: var(--widgetThemeColor);
    opacity: 0.8;
  }

  [data-is-playing='true'] & {
    display: none;
  }

`;
const ContentInner = styled.div `
  padding: ${fluid(20, 24)} 0;
  color: ${brand.black};
`;
const Title = styled.h3 `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 29px;
  margin-bottom: ${fluid(12, 20)};
`;
const Intro = styled.div `
  ${headingStyles};
  font-size: ${fluid(20, 24)};
  line-height: ${fluid(30, 31)};
  margin-bottom: ${fluid(12, 20)};

  p {
    margin: 0;
  }
`;
const SupportText = styled.p `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 29px;
  margin-bottom: 0;
`;
const VideoTestimonialCardStyles = {
    Container,
    ContentArea,
    ContentInner,
    SupportText,
    ImageDesktop,
    ImageMobile,
    Inner,
    Intro,
    MediaContainer,
    MediaHolder,
    QuoteIconImageArea,
    Title,
};
export default VideoTestimonialCardStyles;
